// Shared design-first store for WhatsApp Contacts & Groups.
// Keeps both pages in sync via localStorage until backend APIs are ready.
export const WA_CONTACTS_KEY = "wa_contacts"
export const WA_GROUPS_KEY = "wa_groups"

export const DUMMY_CONTACTS = [
  {
    id: 1,
    contactName: "Rohit Sharma",
    phoneNumber: "+919876543210",
    createdAt: new Date().toISOString(),
  },
  {
    id: 2,
    contactName: "Priya Patel",
    phoneNumber: "+919876543211",
    createdAt: new Date().toISOString(),
  },
  {
    id: 3,
    contactName: "Amit Verma",
    phoneNumber: "+919876543212",
    createdAt: new Date().toISOString(),
  },
  {
    id: 4,
    contactName: "Sneha Iyer",
    phoneNumber: "+919876543213",
    createdAt: new Date().toISOString(),
  },
  {
    id: 5,
    contactName: "Rajesh Kumar",
    phoneNumber: "+919876543214",
    createdAt: new Date().toISOString(),
  },
]

export const DUMMY_GROUPS = [
  {
    id: 1,
    groupName: "Job Alerts",
    contactIds: [1, 2, 3],
    createdAt: new Date().toISOString(),
  },
  {
    id: 2,
    groupName: "VIP Clients",
    contactIds: [4, 5],
    createdAt: new Date().toISOString(),
  },
]

const read = (key, fallback) => {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed : fallback
  } catch {
    // storage unavailable or corrupted, fall back to dummy data
    return fallback
  }
}

const write = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch {
    // ignore storage errors (private mode, quota, etc.)
  }
}

export const loadContacts = () => read(WA_CONTACTS_KEY, DUMMY_CONTACTS)
export const saveContacts = contacts => write(WA_CONTACTS_KEY, contacts)
export const loadGroups = () => read(WA_GROUPS_KEY, DUMMY_GROUPS)
export const saveGroups = groups => write(WA_GROUPS_KEY, groups)

export const normalizePhone = phone => (phone || "").replace(/\D/g, "")

// Indian numbers: static +91 prefix, 10-digit local part
export const toLocal10 = phone => {
  const digits = normalizePhone(phone)
  return digits.length > 10 ? digits.slice(-10) : digits
}
